'use strict';

bbw.directive.bbwPostEditorOpen = ['$rootScope', '$timeout', function($rootScope, $timeout) {
    return {
        scope: {
            'postEditor': '=bbwPostEditorOpen',
            'replyTo': '=?'
        },
        transclude: true,
        templateUrl: bbw.templateUrl('post-editor-open.html'),
        link: function(scope) {
            var editor = scope.postEditor;
            if (angular.isUndefined(editor) || !(editor instanceof bbw.service.PostEditor)) {
                throw new Error('bbw.service.PostEditor required');
            }
            var openEditor = function() {
                if (scope.replyTo) {
                    editor.setReplyTo(scope.replyTo.$model);
                }
                editor.setVisible();
                $rootScope.$safeApply();
                $timeout(function() {
                    editor.focus();
                }, 100);
            };
            scope.postEditorOpen = function() {
                openEditor();
            };
        }
    }

}];
